import React from 'react';
import styled from 'styled-components';
import ArrowMore from 'src/app.feature/academy/component/icon/arrow-more.svg';

type ArrowDirection = 'up' | 'down' | 'left' | 'right';

const CbtDetailMoreButton = ({
  handleShowMore,
  arrow,
}: {
  handleShowMore: () => void;
  arrow: ArrowDirection;
}) => {
  return (
    <Footer>
      <Button onClick={handleShowMore}>
        더보기
        <ArrowIcon arrow={arrow} />
      </Button>
    </Footer>
  );
};

export default CbtDetailMoreButton;

const Footer = styled.div`
  text-align: center;
`;

const Button = styled.button`
  margin: 50px auto;
  padding: 14px 92px;
  background-color: #fff;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;

  svg {
    margin: 0 0 3px 10px;
    vertical-align: middle;
  }

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 13px;
    width: 100%;
  }
`;

const ArrowIcon = styled(ArrowMore)<{ arrow: ArrowDirection }>`
  transform: ${({ arrow }) =>
    arrow === 'up'
      ? 'rotate(180deg)'
      : arrow === 'down'
      ? 'rotate(0deg)'
      : arrow === 'left'
      ? 'rotate(90deg)'
      : 'rotate(-90deg)'};
  transition: transform 0.2s ease-in-out;
`;
